import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';




const rootElement = document.getElementById("root");

ReactDOM.createRoot(rootElement).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <HelmetProvider>
//     <App className="app" />
//   </HelmetProvider>
// );
